'use strict';
var parent = require('../../es/instance/reduce');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/reduce.js
// module id = 766
// module chunks = 13